import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import imageLogo from "../../images/logo.png";
import { Table } from "react-bootstrap";

const Grades = ({ data = [], grades = [] }) => {
  const navigate = useNavigate();

  const { id } = useParams();
  const idGrade = parseInt(id);

  const [itemTitle, setItemTitle] = useState({});
  const [studentGrouping, setStudentGrouping] = useState({});
  const [gradeGrouping, setGradeGrouping] = useState({});

  useEffect(() => {
    if (data) {
      setItemTitle(data[0]);
      setStudentGrouping(data[1]);
      setGradeGrouping(grades[1]);
    }
  }, [data, grades, gradeGrouping, studentGrouping]);

  const handleSignout = () => {
    navigate("/");
  };

  return (
    <div>
      <div className="mt-4">
        <div className="d-flex justify-content-between">
          {/* this is the logo part */}
          <div style={{ width: "200px", height: "200px" }}>
            <img
              style={{ width: "100%", height: "100%" }}
              src={imageLogo}
              alt="logo"
            />
          </div>
          <div>
            <p style={{ fontSize: "44px", fontWeight: "bold" }}>TRANSCRIPT</p>
          </div>
          <div className="" style={{ borderRadius: "18px", padding: "18px" }}>
            <div>
              <button
                style={{
                  borderRadius: "8px",
                  padding: "8px",
                  fontSize: "16px",
                }}
                onClick={handleSignout}
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
        <div className="d-flex flex-column mt-4">
          {data &&
            data[0] &&
            Object.entries(
              data.filter((item) => item.t1key110 === idGrade)[0]
            ).map(([key, value]) => (
              <div>
                <p>
                  {studentGrouping[key] !== "null" && itemTitle[key]}{" "}
                  {studentGrouping[key] !== "null" && ":"}{" "}
                  {studentGrouping[key] !== "null" && value.toString()}
                </p>
              </div>
            ))}
        </div>
        <Table className="mt-4">
          {grades && gradeGrouping && (
            <thead>
              <tr style={{ fontSize: "16px", color: "#777" }}>
                {gradeGrouping["t2item110"] !== "null" && (
                  <th style={{ color: "#777", width: "200px" }}>
                    {grades[0]?.t2item110}
                  </th>
                )}
                {gradeGrouping["t2item130"] !== "null" && (
                  <th style={{ color: "#777", width: "200px" }}>
                    {grades[0]?.t2item130}
                  </th>
                )}
                {gradeGrouping["t2item140"] !== "null" && (
                  <th style={{ color: "#777", width: "200px" }}>
                    {grades[0]?.t2item140}
                  </th>
                )}
                {gradeGrouping["t2item150"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item150}</th>
                )}
                {gradeGrouping["t2item160"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item160}</th>
                )}
                {gradeGrouping["t2item170"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item170}</th>
                )}
                {gradeGrouping["t2item180"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item180}</th>
                )}
                {gradeGrouping["t2item190"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item190}</th>
                )}
                {gradeGrouping["t2item200"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item200}</th>
                )}
                {gradeGrouping["t2item210"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item210}</th>
                )}
                {gradeGrouping["t2item220"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item220}</th>
                )}
                {gradeGrouping["t2item230"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item230}</th>
                )}
                {gradeGrouping["t2item240"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item240}</th>
                )}
                {gradeGrouping["t2item250"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item250}</th>
                )}
                {gradeGrouping["t2item260"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item260}</th>
                )}
                {gradeGrouping["t2item270"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item270}</th>
                )}
                {gradeGrouping["t2item280"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item280}</th>
                )}
                {gradeGrouping["t2item290"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item290}</th>
                )}
                {gradeGrouping["t2item300"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item300}</th>
                )}
                {gradeGrouping["t2item310"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item310}</th>
                )}
                {gradeGrouping["t2item320"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item320}</th>
                )}
                {gradeGrouping["t2item330"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item330}</th>
                )}
                {gradeGrouping["t2item340"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item340}</th>
                )}
                {gradeGrouping["t2item350"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item350}</th>
                )}
                {gradeGrouping["t2item360"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item360}</th>
                )}
                {gradeGrouping["t2item370"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item370}</th>
                )}
                {gradeGrouping["t2item380"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item380}</th>
                )}
                {gradeGrouping["t2item390"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item390}</th>
                )}
                {gradeGrouping["t2item400"] !== "null" && (
                  <th style={{ color: "#777" }}>{grades[0]?.t2item400}</th>
                )}
              </tr>
            </thead>
          )}
          {grades &&
            gradeGrouping &&
            grades
              .filter((grade) => grade?.t2key120 === idGrade)
              .map(
                (filteredData) =>
                  filteredData && (
                    <tbody>
                      <tr style={{ fontSize: "15px" }}>
                        {gradeGrouping["t2item110"] !== "null" && (
                          <td>{filteredData?.t2item110}</td>
                        )}
                        {gradeGrouping["t2item130"] !== "null" && (
                          <td>{filteredData?.t2item130}</td>
                        )}
                        {gradeGrouping["t2item140"] !== "null" && (
                          <td style={{ width: "100px !important" }}>
                            {filteredData?.t2item140}
                          </td>
                        )}
                        {gradeGrouping["t2item150"] !== "null" && (
                          <td>{filteredData?.t2item150}</td>
                        )}
                        {gradeGrouping["t2item160"] !== "null" && (
                          <td>{filteredData?.t2item160}</td>
                        )}
                        {gradeGrouping["t2item170"] !== "null" && (
                          <td>{filteredData?.t2item170}</td>
                        )}
                        {gradeGrouping["t2item180"] !== "null" && (
                          <td>{filteredData?.t2item180}</td>
                        )}
                        {gradeGrouping["t2item190"] !== "null" && (
                          <td>{filteredData?.t2item190}</td>
                        )}
                        {gradeGrouping["t2item200"] !== "null" && (
                          <td style={{ color: "#777" }}>
                            {filteredData?.t2item200}
                          </td>
                        )}
                        {gradeGrouping["t2item210"] !== "null" && (
                          <td>{filteredData?.t2item210}</td>
                        )}
                        {gradeGrouping["t2item220"] !== "null" && (
                          <td>{filteredData?.t2item220}</td>
                        )}
                        {gradeGrouping["t2item230"] !== "null" && (
                          <td>{filteredData?.t2item230}</td>
                        )}
                        {gradeGrouping["t2item240"] !== "null" && (
                          <td>{filteredData?.t2item240}</td>
                        )}
                        {gradeGrouping["t2item250"] !== "null" && (
                          <td>{filteredData?.t2item250}</td>
                        )}
                        {gradeGrouping["t2item260"] !== "null" && (
                          <td>{filteredData?.t2item260}</td>
                        )}
                        {gradeGrouping["t2item270"] !== "null" && (
                          <td>{filteredData?.t2item270}</td>
                        )}
                        {gradeGrouping["t2item280"] !== "null" && (
                          <td>{filteredData?.t2item280}</td>
                        )}
                        {gradeGrouping["t2item290"] !== "null" && (
                          <td>{filteredData?.t2item290}</td>
                        )}
                        {gradeGrouping["t2item300"] !== "null" && (
                          <td>{filteredData?.t2item300}</td>
                        )}
                        {gradeGrouping["t2item310"] !== "null" && (
                          <td>{filteredData?.t2item310}</td>
                        )}
                        {gradeGrouping["t2item320"] !== "null" && (
                          <td>{filteredData?.t2item320}</td>
                        )}
                        {gradeGrouping["t2item330"] !== "null" && (
                          <td>{filteredData?.t2item330}</td>
                        )}
                        {gradeGrouping["t2item340"] !== "null" && (
                          <td>{filteredData?.t2item340}</td>
                        )}
                        {gradeGrouping["t2item350"] !== "null" && (
                          <td>{filteredData?.t2item350}</td>
                        )}
                        {gradeGrouping["t2item360"] !== "null" && (
                          <td>{filteredData?.t2item360}</td>
                        )}
                        {gradeGrouping["t2item370"] !== "null" && (
                          <td>{filteredData?.t2item370}</td>
                        )}
                        {gradeGrouping["t2item380"] !== "null" && (
                          <td>{filteredData?.t2item380}</td>
                        )}
                        {gradeGrouping["t2item390"] !== "null" && (
                          <td>{filteredData?.t2item390}</td>
                        )}
                        {gradeGrouping["t2item400"] !== "null" && (
                          <td>{filteredData?.t2item400}</td>
                        )}
                      </tr>
                    </tbody>
                  )
              )}
        </Table>
      </div>
    </div>
  );
};

export default Grades;
